import { VehicleConditionOptions, VehicleType, VehicleVersion } from 'types';
import { boolean, date, number, object, ObjectSchema, string } from 'yup';

const schemaBase = object().shape<VehicleVersion>({
  firstCirculationDate: date()
    .max(new Date(), "La date ne peut pas être supérieure à la date d'aujourd'hui.")
    .required('Ce champ est obligatoire.'),
  make: string().required('Ce champ est obligatoire.'),
  model: string().required('Ce champ est obligatoire.'),
  version: string().required('Ce champ est obligatoire.'),
  imported: boolean().required('Ce champ est obligatoire.'),
  firstHand: boolean().required('Ce champ est obligatoire.'),
  mileage: number().required('Ce champ est obligatoire.').positive('Le nombre doit être positif').integer(),
  condition: string().oneOf(VehicleConditionOptions).required('Ce champ est obligatoire.'),
  externalColor: string().required('Ce champ est obligatoire.'),
  paintType: string().required('Ce champ est obligatoire.'),
});

const schemaAuto = schemaBase.concat(
  object().shape<VehicleVersion>({
    internalColor: string().required('Ce champ est obligatoire.'),
    seatMaterial: string().required('Ce champ est obligatoire.'),
  }),
);

export const vehicleVersionChoiceSelectionValidationSchema: Record<VehicleType, ObjectSchema | undefined> = {
  AUTO: schemaAuto,
  MOTO: schemaBase,
  UTILITAIRE: schemaAuto,
  CARAVANE: schemaAuto,
  'CAMPING-CAR': schemaAuto,
  UNKNOWN: undefined,
};
